const videoSites = {
	YOUTUBE: Object.freeze({
		NAME: 'YouTube',
		URL: 'https://www.youtube.com/watch?v='
	}),
	VIMEO: Object.freeze({
		NAME: 'Vimeo',
		URL: 'https://vimeo.com/'
	})
}

export default Object.freeze(videoSites)
